/**
 * API configuration for myma-desktop application
 */
import i18n from '../i18n';

const PROD_API = 'https://api.myma.space/api';
const DEV_API = 'https://dev.api.myma.space/api';
const STAGING_API = 'https://staging.api.myma.space/api';
const LOCAL_API = `http://localhost:${process.env.REACT_APP_BACKEND_PORT || '3000'}/api`;

// Determine which API to use based on environment
let API_BASE_URL;
if (process.env.REACT_APP_NODE_ENV === 'prod') {
  API_BASE_URL = PROD_API;
} else if (process.env.REACT_APP_NODE_ENV === 'dev') {
  API_BASE_URL = DEV_API;
} else if (process.env.REACT_APP_NODE_ENV === 'staging') {
  API_BASE_URL = STAGING_API;
} else {
  API_BASE_URL = LOCAL_API;
}

// Auth endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  USER_INFO: `${API_BASE_URL}/auth/userinfo`,
  VERIFY_TOKEN: `${API_BASE_URL}/auth/verify`,
  CLIENTS: `${API_BASE_URL}/admin/clients`,
};

// Helper function to create authorization header
export const createAuthHeader = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json',
  'Accept-Language': i18n.language || 'es',
});

// API function to fetch latest price for a product
export const fetchLatestPrice = async (productId, clientId) => {
  const token = localStorage.getItem('access_token');
  
  try {
    const response = await fetch(
      `${API_BASE_URL}/products/${productId}/latest-price?clientId=${clientId}`,
      {
        headers: createAuthHeader(token),
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export { API_BASE_URL };